import { User } from './../user.model';
import { Router } from '@angular/router';
import { AuthService } from './../auth.service';
import { Component, OnInit } from '@angular/core';
import { Role } from '../user.model';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.css']
})
export class HomeComponent implements OnInit {

  constructor(private authService: AuthService, private router: Router) { }

  user: User;

  ngOnInit() {
    this.authService.user$.subscribe(user => {
      this.user = user;
      if (user) {
        if (user.hasRole(Role.ADMIN) || user.hasRole(Role.TRAVEL_ADVISOR)) {
          this.router.navigate(['/itineraries']);
        } else if (user.hasRole(Role.CUSTOMER)) {
          this.router.navigate(['/customer']);
        }
      }
    });
  }

}
